import { render, staticRenderFns } from "./UnidentifiedReturnsHead.vue?vue&type=template&id=34220fe2&scoped=true"
import script from "./UnidentifiedReturnsHead.vue?vue&type=script&lang=js"
export * from "./UnidentifiedReturnsHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34220fe2",
  null
  
)

export default component.exports